var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMultimedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_multimedia",
    transform: "translate(0.419 0.419)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_201",
    "data-name": "Rect\\xE1ngulo 201",
    width: 25,
    height: 25,
    transform: "translate(-0.419 -0.419)",
    fill: "#585858",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAB86B.tif",
    transform: "translate(2.008 3.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_980",
    "data-name": "Grupo 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_434",
    "data-name": "Trazado 434",
    d: "M3.3,8.419c.039-.151.069-.3.116-.452a2.271,2.271,0,0,1,2.189-1.6c4.843,0,9.687.012,14.53-.008a2.319,2.319,0,0,1,2.381,2.215c.007.628.016,1.256,0,1.884a.459.459,0,1,1-.916-.019c0-.564,0-1.128,0-1.692a1.368,1.368,0,0,0-1.443-1.457q-7.244-.006-14.488,0A1.35,1.35,0,0,0,4.24,8.74q0,4.863,0,9.725V18.7h9.523c.355,0,.562.208.52.521a.413.413,0,0,1-.352.378,1.659,1.659,0,0,1-.32.02H4.249a1.2,1.2,0,0,0,.309.87,1.378,1.378,0,0,0,1.116.487q4.018-.007,8.036,0c.335,0,.536.143.567.4a.46.46,0,0,1-.409.53,1.239,1.239,0,0,1-.171,0q-4.008,0-8.015,0a2.3,2.3,0,0,1-2.314-1.787c-.022-.088-.045-.176-.068-.264Z",
    transform: "translate(-3.301 -6.354)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_435",
    "data-name": "Trazado 435",
    d: "M25.4,25.831a7.053,7.053,0,0,1-.823-.276,2.734,2.734,0,0,1,.734-5.165,8.967,8.967,0,0,1,.908-.055V14.553c0-.521.275-.714.761-.534l3.8,1.407c.414.153.484.253.484.692q0,1.145,0,2.291c0,.462-.277.66-.718.514l-1.822-.609c-.06-.02-.121-.036-.2-.061V18.5c0,1.484-.012,2.969,0,4.454A2.763,2.763,0,0,1,26.224,25.8c-.017,0-.033.024-.049.036Zm1.753-10.76v.295c0,1.842-.007,3.685.005,5.526a.5.5,0,0,1-.73.505,1.436,1.436,0,0,0-.58-.121,1.814,1.814,0,1,0,.321,3.582,1.774,1.774,0,0,0,1.421-1.791q0-2.678,0-5.355c0-.461.276-.657.716-.511l.142.048,1.885.623c0-.5-.005-.978,0-1.454,0-.141-.051-.194-.177-.238-.443-.156-.882-.326-1.323-.489Z",
    transform: "translate(-11.128 -9.37)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M14.318,15.379q0-1.317,0-2.635a.864.864,0,0,1,1.329-.788q2.312,1.32,4.612,2.662a.861.861,0,0,1,0,1.536q-2.3,1.343-4.612,2.663a.863.863,0,0,1-1.331-.782Q14.316,16.707,14.318,15.379Zm.935-2.586v5.19l4.5-2.6Z",
    transform: "translate(-7.673 -8.524)",
    fill: "#585858"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMultimedia);
export default __webpack_public_path__ + "static/media/ic_multimedia.f0ed6f37bee7483c1aa423379451e3e7.svg";
export { ForwardRef as ReactComponent };